import React, { Component } from 'react';
import moment from 'jalali-moment';
import MomentHijri from '../MomentHijri/MomentHijri';

import './CalendarHeader.css';

const days = [
  'یکشنبه',
  'دوشنبه',
  'سه شنبه',
  'چهارشنبه',
  'پنج شنبه',
  'جمعه',
  'شنبه',
]

const persian = [
  'فروردین',
  'اردیبهشت',
  'خرداد',
  'تیر',
  'مرداد',
  'شهریور',
  'مهر',
  'آبان',
  'آذر',
  'دی',
  'بهمن',
  'اسفند',
];

const greogian = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

export default class CalendarHeader extends Component {
  render() {
    return (
      <div className="calendar-header d-flex flex-column">
        <div className="calendar-header__top">
          <h2>{`${days[moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').day()]} ${this.props.date.day} ${persian[this.props.date.month - 1]} ${this.props.date.year}`}</h2>
        </div>
        <div className="calendar-header__bottom d-flex mt-2">
          <div className="ml-4">
            <MomentHijri
              date={`${moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').year()}/${moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').month() + 1}/${moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').date()}
              `}
            />
          </div>
          <div>
            {`${moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').date()} ${greogian[moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').month()]} ${moment.from(`${this.props.date.year}/${this.props.date.month}/${this.props.date.day}`, 'fa', 'YYYY/MM/DD').year()}
            `}
          </div>
        </div>
      </div>
    )
  }
}